import {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {generate} from "../../routes.js"
import mustBeLogged from '../../components/Must/MustBeLogged.jsx'
import StrategyFreelanceContainer from './StrategyFreelanceContainer.jsx'

import actions from '../../components/CurrentUserLoader/actions.js'
import conf from '../../../shared/conf.js'
import PositioningsAndMissions from "../../components/PositioningsAndMissions/PositioningsAndMissions.jsx"


class MyMissionsFreelanceContainer extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.endLoadingCurrentUser
  }

  onFormSuccess = () => {}

  refresh = (profile) => {}

  render() {
    const {currentUser, currentFreelance, endLoadingCurrentUser, ...rest} = this.props
    if (!endLoadingCurrentUser || !currentFreelance) {
      return null
    }

    return (
      <StrategyFreelanceContainer
        currentUser={currentUser}
        isOwner={!!currentUser}
        loading={!endLoadingCurrentUser}
        navbar={true}
        onFormSuccess={this.onFormSuccess}
        profile={{user: currentUser, freelance: currentFreelance}}
        generate={generate}
        refresh={this.refresh}
        view={PositioningsAndMissions}
        {...rest}
      />
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.currentUser.user,
    currentFreelance: state.currentUser.freelance,
    endLoadingCurrentUser: state.currentUser.endLoading,
  }),
  (dispatch) => bindActionCreators(actions, dispatch)
)(mustBeLogged(MyMissionsFreelanceContainer, conf.accountTypes.freelance))